import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ErrorMessages } from '@app/shared/constants';

@Injectable({ providedIn: 'root' })
export class JobTriggerService {
  constructor(
    private http: HttpClient,
  ) {}

  public triggerRewardJob(): Observable<void> {
    return this.http
      .post<void>(
        `${environment.UTILITY_SERVICES_URL}/loyalty-reward/job/trigger`,
        {}
      )
      .pipe(
        catchError((error: any) => {
          const err = error?.error ?? error ?? ErrorMessages.UNEXPECTED ?? 'Unexpected error';
          if (err === undefined) {
            return throwError(() => 'Unknown error occurred');
          }
          return throwError(() => err);
        })
      );
  }

  public triggerReferralJob(): Observable<void> {
    return this.http
      .post<void>(
        `${environment.UTILITY_SERVICES_URL}/referrals/job/trigger`,
        {},
      )
      .pipe(
        catchError((error: any) => {
          const err = error?.error ?? error ?? ErrorMessages.UNEXPECTED ?? 'Unexpected error';
          if (err === undefined) {
            return throwError(() => 'Unknown error occurred');
          }
          return throwError(() => err);
        })
      );
  }

  public triggerMultiLegTrackingSyncJob(): Observable<void> {
    return this.http
      .post<void>(
        `${environment.UTILITY_SERVICES_URL}/multileg-tracking-sync/job/trigger`,
        {},
      )
      .pipe(
        catchError((error: any) => {
          const err = error?.error ?? error ?? ErrorMessages.UNEXPECTED ?? 'Unexpected error';
          if (err === undefined) {
            return throwError(() => 'Unknown error occurred');
          }
          return throwError(() => err);
        })
      );
  }
}
